"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openConfirmModal = exports.openOAuthModal = exports.showSuccessToastFactory = exports.showErrorToastFactory = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _sbToastr = require("skybase-ui/skybase-components/sb-toastr");

var _actions = require("skybase-ui/skybase-core/base/actions");

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var showErrorToastFactory = function showErrorToastFactory(config) {
  return (0, _sbToastr.showErrorToast)(_objectSpread({
    hideTime: 5000
  }, config));
};

exports.showErrorToastFactory = showErrorToastFactory;

var showSuccessToastFactory = function showSuccessToastFactory(config) {
  return (0, _sbToastr.showSuccessToast)(_objectSpread({
    hideTime: 5000
  }, config));
};

exports.showSuccessToastFactory = showSuccessToastFactory;

var openOAuthModal = function openOAuthModal(activeModal) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _actions.openModal)(_constants.O_AUTH_MODALS_KEY, _objectSpread({
    activeModal: activeModal
  }, config));
};

exports.openOAuthModal = openOAuthModal;

var openConfirmModal = function openConfirmModal(config) {
  return openOAuthModal(_constants.CONFIRM_MODAL_KEY, config);
};

exports.openConfirmModal = openConfirmModal;
//# sourceMappingURL=actions.js.map